import SiteLayout from "@/components/site/SiteLayout";
import PageBanner from "@/components/site/PageBanner";
import AboutFounder from "@/components/site/AboutFounder";
import WhyUs from "@/components/site/WhyUs";
import FinalCta from "@/components/site/FinalCta";
import usePageMeta from "@/hooks/usePageMeta";

export default function AboutPage() {
  usePageMeta(
    "About the Founder — Mohd Azam Khan | Gold Mind Business",
    "Meet Mohd Azam Khan, founder of Gold Mind Business — MBA in Marketing with 13+ years of experience in performance-driven digital marketing, brand building and lead generation for businesses across India."
  );
  return (
    <SiteLayout testId="about-page">
      <PageBanner
        title="About Gold Mind Business"
        subtitle="Your Growth, Our Vision — meet the founder behind the growth systems."
      />
      <AboutFounder />
      <WhyUs />
      <FinalCta />
    </SiteLayout>
  );
}
